import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=2c52f190&scoped=true&"
import script from "./PostEditor.vue?vue&type=script&lang=ts&"
export * from "./PostEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PostEditor.vue?vue&type=style&index=0&id=2c52f190&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52f190",
  null
  
)

export default component.exports